import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sharepromotionalcodecontainer',
  templateUrl: './sharepromotionalcodecontainer.component.html',
  styleUrls: ['./sharepromotionalcodecontainer.component.css']
})
export class SharepromotionalcodecontainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/dash-board/sharepromotionalcodecontainer/sharepromotionalcodecontainer.component.ts